export default __webpack_public_path__ + "static/media/Series-X-1.7f27af79.jpg";